import React, { useState } from 'react';
import { toast } from 'react-toastify';
import GenericModal from '../../../components/modal/GenericModal';
import { useManagePostRequest } from '../../../hooks/useManagePostRequest/useManagePostRequest';
import { enviarComunicacionResultadoAPI } from '../../../consumers/backendApisUrls';

// HU-TR-08 CA-05: antes de disparar el correo de resultado, GDH debe poder
// revisar a quién y por qué resultado se le va a comunicar y confirmar
// explícitamente — a diferencia del ícono de "Enviar Correo" de Nuevos Ingresos
// (envío directo, sin preview), acá la HU exige este paso intermedio.
// El contenido real de la plantilla (asunto/cuerpo) todavía no está definido
// por negocio (ver DISENO_HU_TR08_COMUNICACION_RESULTADOS.md, sección 8), así
// que por ahora se confirma contra los datos que ya tiene la fila, no contra
// un preview del correo.
//
// onIniciarEnvio/onFinalizarEnvio (28/09/2026): le avisan a BandejaPostulantes
// para que deshabilite el ícono de avión de esta fila mientras el request está
// en vuelo — mitiga el doble clic/doble envío (no reemplaza la guardia atómica
// del lado del backend, que sigue pendiente, pero cierra el caso más común).
const ConfirmarEnvioComunicacionResultado = ({ toggleModal, refreshPage, postulante = {}, nombreConvocatoria,
    onIniciarEnvio, onFinalizarEnvio }) => {
    const [managePostRequest] = useManagePostRequest();
    const [isSending, setIsSending] = useState(false);

    const handleConfirmar = async () => {
        if (!postulante?.idPostulante || isSending) return;
        setIsSending(true);
        onIniciarEnvio && onIniciarEnvio(postulante.idPostulante);
        // react-toastify 7.0.3 no tiene toast.loading/isLoading (eso es v9+) — un
        // toast.info con autoClose:false + toast.update simula el mismo efecto.
        const toastId = toast.info('Enviando comunicación...', { autoClose: false, closeButton: false });
        try {
            const api = enviarComunicacionResultadoAPI(postulante.idPostulante);
            await managePostRequest(api, {}, async () => {
                toast.update(toastId, {
                    render: 'Comunicación enviada correctamente', type: toast.TYPE.SUCCESS, autoClose: 3000,
                });
                if (refreshPage) await refreshPage();
                toggleModal();
            }, false, async () => {
                toast.dismiss(toastId);
            });
        } finally {
            setIsSending(false);
            onFinalizarEnvio && onFinalizarEnvio(postulante.idPostulante);
        }
    };

    return (
        <GenericModal showModal={toggleModal} titulo="Confirmar envío de comunicación" width="480px">
            <div className="modal-body">
                <p className="text-muted" style={{ fontSize: 13 }}>
                    Se enviará al candidato la comunicación correspondiente a su resultado.
                    Esta acción no se puede deshacer.
                </p>

                <div className="form-group">
                    <label className="modal-label mb-0">Candidato</label>
                    <p className="mb-0">{postulante?.nombrePostulante}</p>
                </div>

                <div className="form-group">
                    <label className="modal-label mb-0">Convocatoria</label>
                    <p className="mb-0">{nombreConvocatoria ?? postulante?.nombreConvocatoria}</p>
                </div>

                <div className="form-group">
                    <label className="modal-label mb-0">Resultado</label>
                    <p className="mb-0">{postulante?.desEstado}</p>
                </div>

                <div className="d-flex justify-content-end mt-3">
                    <button type="button" className="btn btn-outline-secondary mr-2" disabled={isSending}
                        onClick={toggleModal}>
                        Cancelar
                    </button>
                    <button type="button" className="btn generic-button-buscador generic-button-hover-rojo"
                        disabled={isSending} onClick={handleConfirmar}>
                        Enviar comunicación
                    </button>
                </div>
            </div>
        </GenericModal>
    );
};

export default ConfirmarEnvioComunicacionResultado;
